import "./stepButton.scss";
import cn from "classnames";
import { useSelector } from "react-redux";
import loadingIcon from "../../assets/images/booking-flow-images/loading.gif";

const StepButton = ({
  onClick,
  className,
  label,
  blue,
  cyan,
  icon,
  red,
  fontSize,
  social,
  disabled,
  type,
  dark,
  id,
  gray,
  redWithBorder,
  isLeftIcon,
  leftIcon,
  isLoading = false,
  image,
  afterlabelimage
}) => {

  const websiteApiData = useSelector(
    (state) => state.WebsiteDetailsReducer.websiteApiData
  );
  
  return (
    <>
      <div
        className={cn([blue ? "step-button-blue" : cyan ? "step-button-cyan" : gray ? "step-button-gray" : dark ? "step-button-dark" : red ? "step-button-red" : redWithBorder ? "step-button-with-border-red" : social ? "step-button-social" : "step-button-dark"], disabled ? ['step-disabled-button'] : ['step-enabled-button'], isLoading ? ['step-button-loading'] : null)}

      >
        {/* <button disabled={disabled} type={type} onClick={() => {
            if(!isLoading) {
              onClick();
              light ? "step-button-light" : gray ? "step-button-gray" : red ? "step-button-red" : social ? "step-button-social" : "step-button-dark"
            }
          }} className={className}> */}
        <button
          disabled={disabled}
          type={type}
          id={id}
          onClick={onClick}
          // style={disabled && {cursor:"not-allowed"}}
          className={className}
          style={{ background: websiteApiData?.primary_color, color: websiteApiData?.secondary_color, minHeight: '48px', maxHeight: '48px' }}

        >
          {isLoading && false ? (
            <div className="d-flex justify-content-center p-0">
              <img src={loadingIcon} className={"loadingIcon"} />
              {/* <div className="dots-5 "></div> */}
            </div>
          ) : (
            <div className="d-flex justify-content-center">
              {image && <img src={image} alt="icon" className={"image-icon me-2"} />} {/* New line for the image */}

              <div className={fontSize ? "button-font d-flex" : "d-flex"}>
                {isLoading ? (
                  <>
                    {/* <span className={"loader"}></span> */}
                    <img src={loadingIcon} className={"loadingIcon"} />

                  </>
                ) : (
                  <>
                    {isLeftIcon && <div className='leftIcon my-auto'>{leftIcon}</div>}
                    <div className="btnTitle my-auto">{label}</div>
                  </>
                )}
              </div>

              {afterlabelimage && <img src={afterlabelimage} alt="icon" className={"image-icon mx-1"} />}
              {/* &nbsp; */}
              <div className={social ? "social-icon" : "d-flex justify-content-center align-items-center"}>{icon}</div>
              {/* &nbsp; */}
            </div>
          )}
        </button>
      </div>
    </>
  );
};

export default StepButton;
